import { FC } from 'react'

import { registerReactComponent } from './register-react-component'

export type InitReactComponentType = {
  component: FC
  componentName: string
}

type InitReactComponents = () => void

const body = document.querySelector('body')
const MutationObserver = window.MutationObserver

export function initReactInAuthorMode(initComponent?: InitReactComponentType, initReactComponents?: InitReactComponents) {
  const mutationObserver = new MutationObserver(() => {
    if (initComponent?.component) {
      registerReactComponent(initComponent.componentName, initComponent.component)
    } else {
      initReactComponents?.()
    }
  })

  function observeMutations() {
    mutationObserver.observe(body, {
      subtree: true,
      childList: true,
      characterData: true,
    })
  }

  if (window.Granite && window.Granite.author) {
    observeMutations()
  }

  document.dispatchEvent(new window.CustomEvent('ComponentsLoaded'))
}
